/* esm.sh - applesauce-core@5.2.0/helpers/json */
function n(r){try{return JSON.parse(r)}catch{return}}export{n as safeParse};
//# sourceMappingURL=json.mjs.map